import React from 'react';

class Filter extends React.Component {

	constructor(props) {
		super(props);
		
		this.onHandleFilterChange = this.onHandleFilterChange.bind(this);
	}

	
	onHandleFilterChange(event) {
		const filter = {
			...this.props.filter,
			[event.target.name]: event.target.value
		}
		
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	}

	render() {
		const filter = this.props.filter;
		const isSelfDrive = filter.stype === 1; 
	
		return <div className="ibox">
			<div className="ibox-head">
				<h6>BỘ LỌC</h6>
			</div>
			<div className="ibox-body">
				<div className="form-group"> 
					<label className="mb-2">Loại xe</label>
					<select className="form-control" name="vehicleType" onChange={this.onHandleFilterChange} value={filter.vehicleType}> 
						<option value="">Tất cả</option>
						<option value="1">4 chỗ</option>
						<option value="2">7 chỗ</option>
					</select>
				</div>
				{isSelfDrive && <div className="form-group">
					<label className="mb-2">Truyền động</label>
					<select className="form-control" name="transmission" onChange={this.onHandleFilterChange} value={filter.transmission}>
						<option value="1">Số tự động</option>
						<option value="2">Số sàn</option>
					</select>
				</div>}
			</div>
		</div>
	}
}

export default Filter


// WEBPACK FOOTER //
// ./src/components/car/filter.js